// theme: 要切换的主题
const styleChange = (theme) => { 
    if(theme === 'mcd') {
        document.body.style.setProperty('--main-color', '#FBBE00');
        document.body.style.setProperty('--font-color', '#000000');
        document.body.style.setProperty('--linear-gradient-start','#FFA600')
        document.body.style.setProperty('--linear-gradient-end','#FBBE02')
        localStorage.setItem('mainColor','#FBBE00')
        localStorage.setItem('fontColor','#000000')
        localStorage.setItem('gradientStart','#FFA600')
        localStorage.setItem('gradientEnd','#FBBE02')
    } else if(theme === 'yoplait') {
        document.body.style.setProperty('--main-color', '#D46910');
        document.body.style.setProperty('--font-color', '#FFFFFF');
        document.body.style.setProperty('--linear-gradient-start','#ff8500')
        document.body.style.setProperty('--linear-gradient-end','#ffb770')
        localStorage.setItem('mainColor','#D46910')
        localStorage.setItem('fontColor','#FFFFFF')
        localStorage.setItem('gradientStart','#ff8500')
        localStorage.setItem('gradientEnd','#ffb770')
    } else {
        document.body.style.setProperty('--main-color', '#D46910');
        document.body.style.setProperty('--font-color', '#FFFFFF');
        document.body.style.setProperty('--linear-gradient-start','#ff8500')
        document.body.style.setProperty('--linear-gradient-end','#ffb770')
        localStorage.setItem('mainColor','#D46910')
        localStorage.setItem('fontColor','#FFFFFF')
        localStorage.setItem('gradientStart','#ff8500')
        localStorage.setItem('gradientEnd','#ffb770')
    }
}

const initStyleChange = () => {
    document.body.style.setProperty('--main-color', localStorage.getItem('mainColor'));
    document.body.style.setProperty('--font-color', localStorage.getItem('fontColor'));
    document.body.style.setProperty('--linear-gradient-start', localStorage.getItem('gradientStart'));
    document.body.style.setProperty('--linear-gradient-end', localStorage.getItem('gradientEnd'));
}
export {
    styleChange,
    initStyleChange
}
